import type { Floor, SeatCell } from "@busbud/int-schemas/udm";

import { isBusVehicle } from "@app/helpers/departure-helpers";
import { isSeatCell } from "@app/helpers/udm/vehicle";
import { getSegmentsWithSeatSelectionByTripId } from "@app/modules/results/selectors/trips/get-segments-with-seat-selection-by-trip-id";
import { getNormalizedClassName } from "@app/modules/results/utils/classes/normalized-class-name";
import type { ResultsReduxState } from "@app/types/results-redux-types";
import type { TripOptionsMatrix } from "@app/types/results-types";

export const seatClassForTrips = (
  state: ResultsReduxState,
  trip_options_matrix: TripOptionsMatrix,
  seat_id: string
) => {
  const trips_segments = Object.values(trip_options_matrix)
    .flat()
    .map(trip => {
      return getSegmentsWithSeatSelectionByTripId(state, trip.trip_id);
    });

  let class_seat = "";
  trips_segments.forEach(segments => {
    if (segments.length === 0) {
      return;
    }

    segments.find(segment => {
      if (!isBusVehicle(segment?.vehicle.type)) {
        return;
      }
      segment?.vehicle.layout?.find((layout: Floor<SeatCell>) => {
        return layout.cells.find(seats => {
          return seats.find(seat => {
            if (!isSeatCell(seat)) {
              return;
            }

            if (
              seat.id === seat_id &&
              seat.prices &&
              // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
              seat.prices[0].base === 0
            ) {
              // TODO: UDMV4
              // @ts-expect-error fix class for udmv4
              class_seat = getNormalizedClassName(segment.class.name);
              return true;
            }
          });
        });
      });
    });
  });

  return class_seat;
};
